<template lang="pug">
div
  .form-field-label
    span {{ label }}
    span.form-field-require-tag(v-show="required", :title="notifies.required_field")
      | *

  div(:class="[currentFieldIsInvalid ? main_class + ' valid-error' : main_class]")
    q-input(
      ref="phoneInput",
      filled,
      no-error-icon,
      :value="currentField",
      mask="+# (###) ### - ####",
      @input="handlePhoneInput",
      @focus="handlePhoneFocus",
      @blur="handlePhoneBlur",
      @paste.native="handlePhonePaste",
      :label-slot="false",
      :for="name"
    )
      q-icon.cancel-string-field(name="cancel", v-if="currentField", @click.stop="resetField()")

  span.valid-error-message(v-if="currentFieldIsInvalid") {{ valid_error_message }}
</template>

<script>
const {
  formatPhone,
  getDigits,
  hasOnlyPhonePrefix,
  normalizePastedPhone,
  normalizePhoneInputValue,
} = require("@/services/usePhoneFormat");

export default {
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      method: this.parentData.method,
      method_limit: this.parentData.method_limit,
      grid: this.parentData.grid,
      value: this.parentData.data[0].value,
      label: this.parentData.data[0].label,
      name: this.parentData.data[0].name,
      depend_from: this.parentData.data[0].depend_from || {},
      watch: this.parentData.data[0].watch || {},
      required: this.parentData.data[0].require,
      valid_error_message: null,
      main_class: "form-field form-input",
    };
  },

  computed: {
    currentField: {
      get() {
        let form_field = this.currentForm[this.name];
        if (form_field) {
          return form_field["field"];
        } else {
          return undefined;
        }
      },
      set(value) {
        let result = {};
        if (value && value.length > 0) {
          result["field"] = value;
          result["invalid"] = this.invalid(value);
        } else {
          result["invalid"] = this.invalid();
        }
        this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });
        if (!result["invalid"]) {
          this.$store.commit("resetFormFieldValue", {
            grid_name: this.grid,
            field: "invalid_fields",
            value: this.name,
          });
        }
      },
    },

    fieldDependency() {
      return this.checkDependency();
    },
  },

  watch: {
    fieldDependency(newVal, oldVal) {},
  },

  created() {
    this.watchSimpleFieldParents();
  },

  beforeMount() {
    this.$store.commit("createFormField", { grid_name: this.grid, field: this.name });
    this.setField(this.value);
  },

  methods: {
    setField(val) {
      this.currentField = val;
    },

    resetField() {
      this.currentField = "";
    },

    getDigits(value = "") {
      return getDigits(value);
    },

    hasOnlyPhonePrefix(value = this.currentField) {
      return hasOnlyPhonePrefix(value);
    },

    handlePhoneFocus() {
      if (!this.currentField) {
        this.currentField = "7";
      }
    },

    handlePhoneBlur() {
      if (this.hasOnlyPhonePrefix()) {
        this.resetField();
      }
    },

    handlePhoneInput(val) {
      this.currentField = normalizePhoneInputValue(val);
    },

    handlePhonePaste(event) {
      const pastedText = event.clipboardData ? event.clipboardData.getData("text") : "";
      const digits = this.getDigits(pastedText);
      const phoneDigits = this.normalizePastedPhone(digits);

      if (phoneDigits) {
        event.preventDefault();
        this.currentField = this.formatPhone(phoneDigits);
        this.setCaretToEnd();
      }
    },

    setCaretToEnd() {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          const input = this.$refs.phoneInput?.getNativeElement?.();

          if (!input) {
            return;
          }

          const end = input.value.length;

          this.$refs.phoneInput.focus();
          input.setSelectionRange(end, end, "forward");
        });
      });
    },

    normalizePastedPhone(digits) {
      return normalizePastedPhone(digits, this.hasOnlyPhonePrefix());
    },

    formatPhone(digits) {
      return formatPhone(digits);
    },

    invalid(val = undefined) {
      if (this.required) {
        if (val && val.length > 0) {
          this.valid_error_message = null;
          return false;
        } else {
          this.valid_error_message = this.notifies.not_empty;
          return true;
        }
      } else {
        this.valid_error_message = null;
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/styles/forms/fields/string";
</style>
